import Css from './Css.js';
import { useTranslation } from 'react-i18next';

function Confirm(props){
  const {t} = useTranslation();
  const {dialogConfig} = props.dialogConfig;
  const {confirmYes,confirmCancel,confirmExit} = props.method;
  let editorWidth = 1280;
  if(dialogConfig && dialogConfig.editorWidth){
    editorWidth = dialogConfig.editorWidth;
  }
  let diaCss = {
    width: "600px",
    height: "150px",
    backgroundColor: "#333",
    borderRadius: "4px",
    fontSize: "16px",
    color: "#EAEAEA",
    textAlign: "center",
    margin: "80px " + ((editorWidth - 600)/2) + "px"
  }

  let btn1 = "Cancel";
  let btn2 = "Yes";
  let btn0 = "";
  if(dialogConfig && dialogConfig.btn0){
    btn0 = dialogConfig.btn0;
  }
  if(dialogConfig && dialogConfig.btn1){
    btn1 = dialogConfig.btn1;
  }
  if(dialogConfig && dialogConfig.btn2){
    btn2 = dialogConfig.btn2;
  }
  
  let msg = "";
  if(dialogConfig && dialogConfig.msg){
    msg = dialogConfig.msg;
  }

  return (
    <>
    {
      msg ?
      <div style={ Css.diaCss(diaCss) }>
        <span style={ Css.txtDiv }>
          {t(msg)}
        </span>
        {
          (btn0 !== "" && btn1 !== "" && btn2 !== "") ?
          <div style={ Css.btnArea3 }>
            <div style={ Css.btn0((600 - 120*3 - 52)/2) } onClick={ confirmCancel }>{t(btn0)}</div>
            <div style={ Css.btn1(0) } onClick={ confirmExit }>{t(btn1)}</div>
            <div style={ Css.btn2() } onClick={ confirmYes }>{t(btn2)}</div>
          </div> : ""
        }
        {
          (btn0 === "" && btn1 !== "" && btn2 !== "") ?
          <div style={ Css.btnArea2 }>
            <div style={ Css.btn1((600 - 120*2 - 26)/2) } onClick={ confirmCancel }>{t(btn1)}</div>
            <div style={ Css.btn2() } onClick={ confirmYes }>{t(btn2)}</div>
          </div> : ""
        }
      </div>
      : ""
    }
    </>
  )
}

export default Confirm;